import dayjs from "dayjs";
import { emailValidation, urlValidation } from "../../helpers";
/**
 * Custom validation that can be re-used across inputs
 */
export var VALIDATION_MAP = {
    oneLetterOneNumber: function (value) {
        if (/^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).*$/i.test(value)) {
            return true;
        }
        return "Field must contain at least 1 letter and 1 number.";
    },
    email: function (value) {
        if (emailValidation.test(value)) {
            return true;
        }
        return "Must be a valid email.";
    },
    url: function (value) {
        if (urlValidation.test(value)) {
            return true;
        }
        return "Must be a valid url.";
    },
    urlOrEmpty: function (value) {
        if (urlValidation.test(value) || !value) {
            return true;
        }
        return "Must be a valid url.";
    },
    strawberryValidation: function (value) {
        if (value === "strawberry") {
            return true;
        }
        return "example error";
    },
    exampleCustomValidation: function (value) {
        if (value === "1") {
            return true;
        }
        return "example error";
    },
    validDate: function (value) {
        if (value) {
            if (dayjs(value).isValid()) {
                return true;
            }
            return "Please enter a valid date.";
        }
        return true;
    },
    hex: function (value) {
        return (!value ||
            /^#([0-9a-f]{3}){1,2}$/gi.test(value) ||
            "Please only provide colors as HEX codes (eg. #FFFFFF)");
    },
};
